import React from "react";
import { makeStyles, Typography, RaiseColors } from "client/componentLibrary";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles(function (theme) {
  return {
    attributeText: {
      display: "flex",
      alignItems: "baseline"
    },
    verticalValueContainer: {
      marginLeft: 8,
      marginTop: 2
    },
    leftAttributeContainer: {
      marginLeft: 8
    }
  };
});
var CoreAttributeText = function CoreAttributeText(_ref) {
  var attribute = _ref.attribute,
    isHorizontal = _ref.isHorizontal;
  var classes = useStyles();
  return /*#__PURE__*/_jsxs("div", {
    className: classes.attributeText,
    children: [/*#__PURE__*/_jsx(Typography, {
      noWrap: true,
      color: RaiseColors.gray400,
      weight: isHorizontal ? "regular" : "semibold",
      children: attribute === null || attribute === void 0 ? void 0 : attribute.subtitle
    }), /*#__PURE__*/_jsx("div", {
      className: isHorizontal ? classes.leftAttributeContainer : classes.verticalValueContainer,
      children: /*#__PURE__*/_jsx(Typography, {
        noWrap: true,
        color: RaiseColors.black,
        weight: isHorizontal ? "semibold" : "regular",
        children: attribute === null || attribute === void 0 ? void 0 : attribute.value
      })
    })]
  });
};
export default CoreAttributeText;